export default "__VITE_ASSET__3ebefb3b__"